module.exports = __webpack_public_path__ + "static/media/registered.6e3e2937.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/registered.png
// module id = 457
// module chunks = 0